import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import {
  AuthForm,
  Home,
  MainPage,
  Profile,
  PropertyRequestWizard,
  PropertyWizard,
  AgentsPanel,
  AgentApplicationWizard,
  DevelopersPanel,
  DeveloperRegistration,
  DeveloperProfiles,
  TransactionsPage,
  GISPlatform
} from './pages';
import ListingProfile from './pages/MainPage/ListingProfile';
import appRoutes from './config/routes';


function PropertyWizardRoute() {
  const [searchParams] = useSearchParams();
  const propertyId = searchParams.get('propertyId') || undefined;
  return <PropertyWizard propertyId={propertyId} />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path={appRoutes.home} element={<Home />} />
        <Route path={appRoutes.legacyHome} element={<Navigate to={appRoutes.home} replace />} />
        <Route path={appRoutes.main} element={<MainPage />} />
        <Route path={appRoutes.login} element={<AuthForm />} />
        <Route path={appRoutes.register} element={<AuthForm />} />
        <Route path={appRoutes.profile} element={<Profile />} />
        <Route path={appRoutes.propertyWizard} element={<PropertyWizardRoute />} />
        <Route path={appRoutes.agents} element={<AgentsPanel />} />
        <Route path={appRoutes.listingProfile} element={<ListingProfile />} />
        <Route path={appRoutes.propertyRequest} element={<PropertyRequestWizard />} />
        <Route path={appRoutes.agentApplication} element={<AgentApplicationWizard />} />
        <Route path={appRoutes.developers} element={<DeveloperProfiles />} />
        <Route path={appRoutes.developerRegister} element={<DeveloperRegistration />} />
        <Route path={appRoutes.developerProjects} element={<DevelopersPanel />} />
        <Route path={appRoutes.developerProfiles} element={<DeveloperProfiles />} />
        <Route path={appRoutes.transactions} element={<TransactionsPage />} />
        <Route path={appRoutes.transactionDetail} element={<TransactionsPage />} />
        <Route path={appRoutes.gisPlatform} element={<GISPlatform />} />

      </Routes>
    </Router>
  );
}

export default App;
